<!-- the backdrop and the panel take mouse clicks only; the keyboard closes the palette with Escape -->
<!-- eslint-disable-next-line @angular-eslint/template/click-events-have-key-events, @angular-eslint/template/interactive-supports-focus -->
<div class="aca-palette__backdrop" *ngIf="open()" (click)="close()">
  <!-- eslint-disable-next-line @angular-eslint/template/click-events-have-key-events, @angular-eslint/template/interactive-supports-focus -->
  <div class="aca-palette" role="dialog" aria-modal="true" [attr.aria-label]="'DMS.PALETTE.TITLE' | translate" (click)="$event.stopPropagation()">
    <div class="aca-palette__input">
      <mat-icon>search</mat-icon>
      <input
        #queryInput
        type="text"
        [ngModel]="query"
        (ngModelChange)="onQuery($event)"
        (keydown)="onKey($event)"
        [placeholder]="'DMS.PALETTE.PLACEHOLDER' | translate"
        [attr.aria-label]="'DMS.PALETTE.PLACEHOLDER' | translate"
        role="combobox"
        aria-expanded="true"
        aria-controls="aca-palette-list"
        autocomplete="off"
        spellcheck="false"
      />
      <kbd>Ctrl K</kbd>
    </div>

    <div class="aca-palette__list" id="aca-palette-list" role="listbox">
      <ng-container *ngIf="rows().length; else empty">
        <button
          type="button"
          role="option"
          class="aca-palette__row"
          [class.aca-palette__row--sel]="indexOf(row) === selected()"
          [attr.aria-selected]="indexOf(row) === selected()"
          *ngFor="let row of rows()"
          (mouseenter)="selected.set(indexOf(row))"
          (click)="activate(row)"
        >
          <!-- two guarded blocks rather than ngIf/else: an else template does not narrow the row's type -->
          <ng-container *ngIf="row.kind === 'cmd'">
            <mat-icon class="aca-palette__icon">{{ row.command.icon }}</mat-icon>
            <span class="aca-palette__label">{{ row.label }}</span>
            <span class="aca-palette__kind">{{ 'DMS.PALETTE.KIND_PAGE' | translate }}</span>
          </ng-container>
          <ng-container *ngIf="row.kind === 'doc'">
            <mat-icon class="aca-palette__icon">{{ row.hit.isFolder ? 'folder' : 'description' }}</mat-icon>
            <span class="aca-palette__label">
              {{ row.hit.name }}
              <span class="aca-palette__path" *ngIf="row.hit.location">{{ row.hit.location }}</span>
            </span>
            <span class="aca-palette__kind">{{ 'DMS.PALETTE.KIND_DOC' | translate }}</span>
          </ng-container>
        </button>
      </ng-container>
      <ng-template #empty>
        <div class="aca-palette__empty">
          {{ (searching() ? 'DMS.PALETTE.SEARCHING' : 'DMS.PALETTE.EMPTY') | translate }}
        </div>
      </ng-template>
    </div>
  </div>
</div>
